import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Notification from './Notification';
import CookiesNotification from './CookiesNotification';
import Navigation from './Navigation';
import { goToPage, changeDevice, cookieConsent, consumerType } from '../../actions/environment';
import { clientInit, changeAddressInput } from '../../actions/checkout';
import { addEvent, removeEvent, hasClass, addClass, removeClass, offset, scrollTo, height } from '../../utils/dom';
import { translate } from '../../utils/locale';
import s from './Header.scss';

let headerHeight = 102;
const breakPoints = [900, 600];
const media = { w_600: 'mobile', w_900: 'tablet', w_1200: 'desktop' };

class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			grid: false,
			menuPopupHeight: 'auto',
			menuOffset: null,
		};

		this.headerElement = React.createRef();
	}

	componentDidMount() {
		if (typeof window !== 'undefined') {
			const $html = document.querySelector('html');
			let currentWidth = breakPoints.reduce((acc, bp) => (bp > window.innerWidth ? bp : acc), 1200);
			let device = media[`w_${currentWidth}`];
			if (device === 'tablet' || device === 'desktop') headerHeight = 102;
			else headerHeight = 72;

			this.props.clientInit();
			this.props.changeDevice(device);

			// Wait for page to be rendered with all relevant elements.
			const initiateSiteListeners = () => {
				if (!this.headerElement) {
					setTimeout(initiateSiteListeners, 200);
				}

				const startTop = window.pageYOffset || document.documentElement.scrollTop;
				const menuOffset = offset(this.headerElement.current).top + headerHeight;
				const menuOffsetWindowTop = startTop > offset(this.headerElement.current).top ? 0 : offset(this.headerElement.current).top;
				const bottomFunctions = window.innerWidth < 600 ? 166 : 0;

				let isScrolled = false;
				let headerIsFixed = false;
				let isScrollingUp = false;
				let lastScrolledDown = 0;
				let lastScrolledUp = 1e5;

				if (this.state.menuOffset === null) {
					this.setState({
						menuOffset,
						menuPopupHeight: window.innerHeight - menuOffsetWindowTop - bottomFunctions,
					});
				}

				const resizeEvent = () => {
					const updatedWidth = breakPoints.reduce((acc, bp) => (bp > window.innerWidth ? bp : acc), 1200);

					// Switch between mobile, table and desktop.
					if (currentWidth !== updatedWidth) {
						device = media[`w_${updatedWidth}`];
						this.props.changeDevice(device);
						currentWidth = updatedWidth;
						if (device === 'tablet' || device === 'desktop') headerHeight = 102;
						else headerHeight = 72;
					}
				};

				addEvent(window, 'resize.logoHeader', () => {
					window.requestAnimationFrame(resizeEvent);
				});

				const scrollEvent = () => {
					const top = window.pageYOffset || document.documentElement.scrollTop;
					if (this.state.menuOffset === null) {
						this.setState({
							menuOffset: offset(this.headerElement.current).top + headerHeight,
						});
					}
					const documentHeight = height(document);

					// make logo sticky when level with header.
					if (!headerIsFixed && top >= this.state.menuOffset) {
						headerIsFixed = true;
						addClass($html, 'u_headerIsFixed');
					} else if (headerIsFixed && top < this.state.menuOffset - headerHeight) {
						headerIsFixed = false;
						removeClass($html, 'u_headerIsFixed');
					}

					if (top > documentHeight - window.innerHeight - 102 && isScrolled) {
						// this.setState({ headerRotated: false });
						isScrolled = false;
						addClass($html, 'u_pageIsScrolled');
					} else if (top > 0 && !isScrolled) {
						addClass($html, 'u_pageIsScrolled');
						isScrolled = true;
					} else if (top === 0) {
						removeClass($html, 'u_pageIsScrolled');
						removeClass($html, 'u_headerIsFixed');
						removeClass($html, 'u_pageIsScrollingUp');
						isScrolled = false;
						headerIsFixed = false;
					}

					if (top > lastScrolledDown) lastScrolledDown = top;
					if ((top < lastScrolledUp && isScrollingUp) || !isScrollingUp) lastScrolledUp = top;

					// Middle scrolling changing directions
					if (lastScrolledDown - top > 102 && !isScrollingUp) {
						addClass($html, 'u_pageIsScrollingUp');
						isScrollingUp = true;
					}
					if (top - lastScrolledUp > 102 && isScrollingUp) {
						removeClass($html, 'u_pageIsScrollingUp');
						lastScrolledDown = top;
						isScrollingUp = false;
					}
				};

				addEvent(window, 'scroll.logoHeader', () => {
					window.requestAnimationFrame(scrollEvent);
				});
			};

			initiateSiteListeners();

			if ('ontouchstart' in document.documentElement) {
				removeClass($html, 'no-touchevents');
				addClass($html, 'touchevents');
			}

			if (hasClass($html, 'no-touchevents')) {
				addEvent(window, 'touchstart.touchTest', () => {
					removeClass($html, 'no-touchevents');
					addClass($html, 'touchevents');
					removeEvent(window, 'touchstart.touchTest');
				});
			}

			addEvent(document.getElementById('root'), 'click.linkCapture', (e) => {
				const $link = e.target.closest('a');
				const linkLocation = ($link && $link.getAttribute('href')) || '';

				if ($link && hasClass($link, 'linkCapture')) {
					e.preventDefault();
					if (linkLocation.indexOf('#') === 0) {
						const $id = document.getElementById(linkLocation.slice(1));
						if ($id) {
							scrollTo(400, offset($id).top);
						}
					} else {
						this.props.goToPage(linkLocation);
					}
				}
			});

			addEvent(window, 'keydown.general', (e) => {
				if (e.key === 'Escape') {
					if (this.state.grid) this.setState({ grid: false });
				} else if (e.shiftKey && e.ctrlKey && e.key === 'A') {
					// ctrl + shift + a = Toggle grid
					this.setState((prevState) => ({ grid: !prevState.grid }));
				}
			});
		}
	}

	componentWillUnmount() {
		removeEvent(window, 'keydown.general');
		removeEvent(window, 'scroll.logoHeader');
		removeEvent(window, 'resize.logoHeader');
		removeEvent(window, 'message.acuityListener');
	}

	notificationRemovedHandler = () => {}

	render() {
		const { properties, navigation, setup, header, location, newPage, changeConsumer } = this.props;
		const { grid } = this.state;
		// const deliveryError = translate(setup, 'unableToSendToCountry').replace('%country%', countryName);
		if (properties.siteInitiated === false || properties.siteClosed === true) return null;

		return (
			<>
				{/* setup.unableToSendToCountry && <Notification type="error" content={[{ name: 'unableToSendToCountry', text: deliveryError }]} setup={setup} /> */}
				{ header.cookies && <CookiesNotification content={header.cookies} setup={setup} cookieConsent={this.props.cookieConsent} /> }
				{ header.campaign && <Notification type="campaign" content={header.campaign} setup={setup} newPage={newPage} /> }
				{ header.popup && <Notification type="popup" content={header.popup} setup={setup} /> }
				{ setup.consumerTypeActive && header.consumer && <Notification type="consumer" content={header.consumer} setup={setup} consumerType={this.props.consumerType} reshowNotification={changeConsumer} /> }
				<div className={s.header_transparency} />
				<header id="top" className={s.header} ref={this.headerElement}>
					<div className={s.header_fixedContainer}>
						<Navigation navigation={navigation} setup={setup} menuPopupHeight={this.state.menuPopupHeight} campaignMenu={header.campaignMenu} location={location} />
					</div>
				</header>
				{ grid && <div className={s.grid}><div /></div> }
			</>
		);
	}
}

const mapState = ({ environment, location, filter, productCache, pageStatus }) => {
	const { properties, navigation, setup, header, pageType, countryName, changeConsumer } = environment;
	return {
		properties,
		navigation,
		setup,
		header,
		pageType,
		countryName,
		changeConsumer,
		location,
		filter,
		productCache,
		newPage: pageStatus.seed,
	};
};

export default hot(module)(connect(mapState, {
	cookieConsent,
	consumerType,
	changeAddressInput,
	goToPage,
	clientInit,
	changeDevice,
})(Header));
